import { useSelector } from 'react-redux';

import { FinanceRate } from '@kanda-libs/ks-frontend-services';

import { useCurrentJob, useCurrentJobLead } from 'hooks';
import { selectors } from 'store';
import { getLowestMonthlyRate } from 'utils';

export interface WelcomeHook {
  id: string;
  monthlyCost: number;
  financeOption?: FinanceRate;
  jobTotalForMinimumMonthlyCost: number;
}

export default function useWelcome(): WelcomeHook {
  const { id = '' } = useSelector(selectors.getPathKey);
  const { job } = useCurrentJob();
  const { lead } = useCurrentJobLead();

  const { monthlyCost, financeOption, jobTotalForMinimumMonthlyCost } =
    getLowestMonthlyRate(
      job,
      lead,
      lead?.finance_options || job?.finance_options || [],
    );

  return {
    id,
    monthlyCost,
    financeOption,
    jobTotalForMinimumMonthlyCost,
  };
}
